import { htmlElem } from './globals';

const getNavHeight = () => {
    const elem = htmlElem.querySelector('header');
    elem 
        ? document.documentElement.style.setProperty(
            '--nav-height',
            elem.clientHeight + 'px'
        )
        : null
};

const getFooterHeight = () => {
    const elem = htmlElem.querySelector('footer');
    elem 
        ? document.documentElement.style.setProperty(
            '--footer-height',
            elem.clientHeight + 'px'
        )
        : null
}

export {
    getNavHeight,
    getFooterHeight
}